// src/services/auth.service.js
import axios from 'axios';

const AUTH_TOKEN_KEY = 'auth_token';
const API_URL = process.env.VUE_APP_API_URL;  // Defina fora da classe
const API_KEY = process.env.VUE_APP_API_KEY; // Nova variável de ambiente


class AuthService {
    constructor() {
        // Primeiro, salve as variáveis de ambiente em constantes para debug
        this.apiUrl = API_URL;
        this.apiKey = API_KEY; // Nova variável de ambiente
        // console.log('Constructor - API URL:', this.apiUrl);
        //const apiUsername = process.env.VUE_APP_API_USERNAME;
        //const apiPassword = process.env.VUE_APP_API_PASSWORD;

        // Log para debug
        // console.log('Variáveis de ambiente:', {
        //    apiUrl: this.apiUrl,  // Use this.apiUrl aqui
        //    apiUsername,
        //    apiPassword
        //});

        this.api = axios.create({
            // apiUrl,
            // apiUsername,
            // apiPassword,
            baseURL: this.apiUrl,  // Adicione a baseURL aqui
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-API-Key': this.apiKey // Adiciona API key em todas as requisições

            }
        });

        // Adiciona o interceptor para incluir o token em todas as requisições
        this.api.interceptors.request.use(
            (config) => {
                const token = this.getToken();
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Interceptor para tratar erros de autenticação
        this.api.interceptors.response.use(
            (response) => response,
            async (error) => {
                if (error.response?.status === 401) {
                    this.clearToken();
                    await this.login(); // Tenta fazer login novamente
                }
                return Promise.reject(error);
            }
        );
    }

    // src/services/auth.service.js
    async login(email, password) {
        try {
            const response = await this.api.post(`${this.apiUrl}/token`, {
                username: email,
                password: password
            });
            
            const token = response.data.access_token;
            this.setToken(token);

            console.log("token", token);
            
            return response;

        } catch (error) {
            // Agora estamos tratando o erro antes de lançá-lo
            console.error('Erro no login:', error);
            // Podemos adicionar lógica adicional aqui, como:
            if (error.response?.status === 401) {
                throw new Error('Credenciais inválidas');
            }
            throw error;
        }
    }

    async forgotPassword(email) {
        try {
            const response = await this.api.post(`${this.apiUrl}/forgot-password`, { email: email });
            return response.data;
        } catch (error) {
            console.error('Erro ao solicitar recuperação de senha:', error);
            throw error;
        }
    }
    
    async resetPassword(token, newPassword) {
        try {
            const response = await this.api.post(`${this.apiUrl}/reset-password`, {
                token: token,
                new_password: newPassword
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao redefinir senha:', error);
            throw error;
        }
    }

    setToken(token) {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
    }

    getToken() {
        return localStorage.getItem(AUTH_TOKEN_KEY);
    }

    clearToken() {
        localStorage.removeItem(AUTH_TOKEN_KEY);
    }

    async makeRequest(config) {
        try {
            // if (!this.getToken()) {
            //     await this.login();
            // }

             // Garantir que a URL base está correta
             const finalConfig = {
                ...config,
                baseURL: this.apiUrl  // Adicione a baseURL aqui também
            };
            console.log("finalConfig", finalConfig);
            return await this.api(finalConfig);
            //return await this.api(config);
        } catch (error) {
            console.error('Erro na requisição:', error);
            throw error;
        }
    }
}

export default new AuthService();